import { render } from "./role.vue?vue&type=template&id=0ce7dafa&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=0ce7dafa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ce7dafa"

export default script